module.exports = __webpack_public_path__ + "img/107.6.c36cbea9.png";